import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector, useDispatch } from 'react-redux';
import { resetPageData } from '@/store/reducers/pageSlice';
import { selectPageCanonical, selectPageDescription, selectPageTitle } from '@/store/selectors/pageSelectors';

interface SEOProps {
	title?: string;
	description?: string;
	canonical?: string;
}

const SEO: React.FC<SEOProps> = ({ title, description, canonical }) => {
	const dispatch = useDispatch();
	const pageTitle = useSelector(selectPageTitle);
	const pageDescription = useSelector(selectPageDescription);
	const pageCanonical = useSelector(selectPageCanonical);

	const finalTitle = title || pageTitle;
	const finalDescription = description || pageDescription;
	const finalCanonical = canonical || pageCanonical;

	useEffect(() => {
		return () => {
			dispatch(resetPageData());
		}
	}, [dispatch]);

	return (
		<Helmet>
			{finalTitle && <title>{finalTitle}</title>}
			{finalDescription && <meta name="description" content={finalDescription} />}
			{finalCanonical && <link rel="canonical" href={finalCanonical} />}
		</Helmet>
	);
};

export default SEO;
